module.exports = __webpack_public_path__ + "static/media/first-project-ill.03ef34d8.svg";